<template src="./LockerDetails/LockerDetails.html"></template>
<script>
import { Webapi } from '@/Webapi'

function compare(a, b) {
    if (a[0] < b[0]) {
        return -1
    }
    if (a[0] > b[0]) {
        return 1
    }
    return 0
}

export default {
    name: 'LockerDetails',
    props: {
        consignment: Object,
    },
    data: () => ({
        lockerAvailability: Array,
        showAllParcels: false,
        expandable: false,
    }),
    computed: {
        parcels() {
            return this.$props.consignment.parcels
        },
    },
    mounted() {
        if (this.$props.consignment.lockerId) {
            Webapi()
                .locker(this.$props.consignment.lockerId)
                .then((response) => {
                    this.lockerAvailability = Object.keys(response)
                        .map((key) => [String(key), response[key]])
                        .sort(compare)
                })
                .catch((err) => console.error(err))
        }
        if (this.$props.consignment.parcels.length > 5) {
            this.expandable = true
        }
    },
    methods: {
        getBoxSize(boxSize) {
            switch (boxSize) {
                case 'BOX_240_70_340':
                    return 'Extra Small'
                case 'BOX_265_100_600':
                    return 'Small'
                case 'BOX_265_150_600':
                    return 'Medium'
                case 'BOX_265_225_600':
                    return 'Large'
                case 'BOX_400_300_600':
                    return 'Extra Large'
                default:
                    return boxSize
            }
        },
        toggleShowAllParcels() {
            this.showAllParcels = !this.showAllParcels
        },
        getOccupiedAmount(available, capacity) {
            return capacity - available
        },
    },
}
</script>
<style lang="scss" scoped>
.card {
    margin-bottom: 10px;
}

.task-dashboard {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    border-left: solid 0px slategrey;
}

.dashboard-row {
    display: flex;
    width: 100%;
}

.parcels-table {
    width: 80%;
    margin-right: 10px;
}
.locker-info {
    width: 20%;
    margin-right: 10px;
}
.tableFixHead {
    overflow-y: auto;
    height: fit-content;
    max-height: 300px;
    min-height: 300px;
}
.tableFixHead thead th {
    position: sticky;
    top: 0;
}
table {
    border-collapse: collapse;
    width: 100%;
}
th,
td {
    padding: 8px 16px;
}
th {
    background: white;
}
.locker-size-full {
    color: red;
}
.locker-size-available {
    color: #48c774;
}
.small-button {
    max-height: 1.5em;
    padding-right: 22px;
    width: -webkit-fill-available;
    &:active {
        border-color: #dbdbdb !important;
    }
    &:focus {
        border-color: #dbdbdb !important;
        box-shadow: none;
    }
}
.table-header {
    z-index: 1;
    width: 115px;
}
.expand {
    max-height: fit-content;
}
.fas {
    position: absolute;
    margin-left: 85%;
}
</style>
